import { useEffect, useState } from "react";
import axios from "axios";
import { getAuth } from "../../auth";
import { apiUrl } from "../../../utils/api";

/**
 * Mesma regra do menu lateral: operations.cashier
 * (módulo 27 / operação 183 — "Abrir caixa").
 */
export function useCanOpenCaixa(): boolean {
  const [canOpen, setCanOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const auth = getAuth();
    const token = auth?.api_token;

    if (!token) {
      setCanOpen(false);
      return;
    }

    axios
      .get(`${apiUrl()}/sidebar-menu`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (!cancelled) {
          setCanOpen(!!response?.data?.operations?.cashier);
        }
      })
      .catch(() => {
        if (!cancelled) setCanOpen(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return canOpen;
}
